{
  "Id": "ICH WÜRDE:",
  "IdPlaceholder": "[Automatisch zugewiesen]",
  "NamePlaceholder": "Zentrale Verwaltungsumgebung",
  "BillingId": "Abrechnungs-ID:",
  "ParentCme": "Übergeordnete CME:",
  "DescriptionIsRequired": "Beschreibung ist erforderlich.",
  "CMEDetails_ButtonHelpLabel": "Hilfe?",
  "CMEDetails_ButtonSubmitLabel": "OK",
  "CMEDetails_ButtonCancelLabel": "Absagen",
  "CMEDetails_PromptMessage": "Möchten Sie dieses Fenster wirklich schließen? Alle geänderten Konfigurationen gehen beim Schließen verloren.",
  "CMEDetails_PromptConfirm": "Ja",
  "CMEDetails_PromptCancel": "Absagen",
  "CMEDetails_Description": "Beschreibung:",
  "NAME": "CMEDetails",
  "CMEDetails_ProviderIDS": "SSO-Anbieter-IDs:",
  "CMEDetails_ProviderIDS_Help": "Leer lassen, es sei denn, Sie konfigurieren Single-Sign On (SSO). Wenn Sie SSO verwenden, wurde Ihre Anbieter-ID bereits angegeben.",
  "CMEDetails_ProviderIDS_Validation_NoMoreThan5": "Es sind nicht mehr als 5 SSO-Anbieter-IDs zulässig.",
  "CMEDetails_ProviderIDS_Validation_IDsInvalid": "Achten Sie darauf, dass die Anbieter-IDs nur aus Buchstaben, Zahlen, Bindestrichen oder Unterstrichen bestehen, nicht länger als 15 Zeichen sind und in einer durch Kommata getrennten Liste stehen.",
  "CMEDetails_Disable_Akixi_Login": "Deaktivieren Sie die Anmeldefunktion für den Benutzernamen:"
}